import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { TASK_TERM } from "../apiRoutes";

const mutateUpdateTaskTerm = async ({ id,data }: { id:string; data: FieldValues }) => {
  return await axiosAuth.put(`${TASK_TERM}${id}`, data);
};

const useUpdateTaskTermMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateTaskTerm,
    ...queryParams,
  });

export default useUpdateTaskTermMutation;
